export default __webpack_public_path__ + "e3e0c61b6b886743387a9a45a212fdb3.png";